"use strict";
angular.module('emun.stockchecker', ['emun.auth', 'webutils', 'webforms', 'webmodals', 'ui.router']);